export const menuTransition = '0.22s ease-in-out';
